import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { DragHandle } from '../drag-handle/DragHandle';
import { PriorityBadge } from '../priority-badge/PriorityBadge';
import { StatusBadge, QueueStatus } from '../status-badge/StatusBadge';
import { QueueStat } from '../queue-stat/QueueStat';
import { PinToggle } from '../pin-toggle/PinToggle';

export interface QueueCardRow1Props {
  priority: number;
  queueName: string;
  description: string;
  status: QueueStatus;
  totalInQueue: number;
  criticalAged: number;
  onDragStart?: (e: React.DragEvent<HTMLSpanElement>) => void;
  isDragging?: boolean;
  isPinned?: boolean;
  onTogglePin?: () => void;
  canTogglePin?: boolean;
}

export const QueueCardRow1: React.FC<QueueCardRow1Props> = ({
  priority,
  queueName,
  description,
  status,
  totalInQueue,
  criticalAged,
  onDragStart,
  isDragging = false,
  isPinned = false,
  onTogglePin,
  canTogglePin = false
}) => {
  return (
    <Flex
      className="cmx-queue-card-row1"
      alignItems="center"
      gap="3"
      width="100%"
      data-testid="queue-card-row1"
    >
      <DragHandle onDragStart={onDragStart} isActive={isDragging} />
      <PriorityBadge position={priority} prefix={isPinned ? 'P' : undefined} />
      <Text
        className="cmx-queue-card-row1__name"
        maxW="40%"
        minW="0"
        fontWeight="600"
        fontSize="14px"
        noOfLines={1}
        title={queueName}
      >
        {queueName}
      </Text>
      {canTogglePin && <PinToggle isPinned={isPinned} onClick={onTogglePin} />}
      {status !== 'healthy' && <StatusBadge status={status} />}
      <Text
        className="cmx-queue-card-row1__description"
        flex="1"
        minW="0"
        noOfLines={1}
        title={description}
        data-testid="queue-card-row1-description"
      >
        {description}
      </Text>
      <Flex className="cmx-queue-card-row1__stats" gap="6" flexShrink={0}>
        <QueueStat value={totalInQueue} label="Total in Queue" />
        <QueueStat
          value={criticalAged}
          label="Critical Aged"
          colorOverride="var(--color-queue-critical)"
        />
      </Flex>
    </Flex>
  );
};

QueueCardRow1.displayName = 'QueueCardRow1';
export default QueueCardRow1;
